/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const AcceptButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.save}
      iconName="check"
      tooltip={formatMessage({ id: "common.accept" })}
      css={labellessButtonCss}
      {...props}
      data-cy="accept-button"
    />
  );
};

export default AcceptButton;
